import { Controller } from "@hotwired/stimulus"

// Toggles the hidden schedule occurrences on the public event page and swaps the
// button label between "Show N more dates" and "Show fewer dates".
export default class extends Controller {
  static targets = ["hidden", "toggle"]

  toggle() {
    const expanded = this.hiddenTarget.classList.toggle("d-none") === false
    this.toggleTarget.textContent = expanded
      ? this.toggleTarget.dataset.lessLabel
      : this.toggleTarget.dataset.moreLabel
  }
}
